import { Translation } from '@ps/web-shared-components';
import React from 'react';
import type { SyntheticEvent } from 'react';
import { useDispatch } from 'react-redux';

import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';
import type { CardViewProps } from '@swf/components/StarsMPNotification/config/NotificationTypes';
import { geti18NValueConfig } from '@swf/components/StarsMPNotification/utils';
import type { Dispatch } from '@swf/core/store';
import type { BonusNotification } from '@swf/core/types/Notification';
import { translatedLink } from '@swf/core/utils';
import { NotificationContainer } from '@swf/notification';

import sharedStyles from '../../../styles/shared.scss';
import Buttons from '../../Buttons/Buttons';

import {
  TXTCLI_Casino,
  TXTCLI_Your_N0_N1_N2_Instant_Bonus_wi_ELL,
  TXTCLI_in_N0_h_N1_min,
  TXTWCL_If_you_wish_to_see_more_inform_ELL
} from './Expired.messages.json';

const Expired: React.FC<CardViewProps & { cardData: BonusNotification }> = ({
  cardData: {
    currency,
    type,
    description,
    attributes,
    notificationId,
    rollId,
    initialAmount,
    expiresIn
  },
  viewConfig: { title, actions },
  onClickPrimaryAction
}) => {
  const { modal } = useDispatch<Dispatch>();

  const viewBonuses = (e: SyntheticEvent) => {
    e.preventDefault();
    modal.replace([{ path: `/account/my-stars/bonus/instant-bonuses/${rollId}` }]);
  };

  return (
    <NotificationContainer
      title={<Translation {...title.tag} values={geti18NValueConfig(title.values, attributes)} />}
      bodyClass={sharedStyles.alignLeft}
    >
      <Translation
        tagName="p"
        {...TXTCLI_Your_N0_N1_N2_Instant_Bonus_wi_ELL}
        values={{
          0: <CurrencyAmount value={initialAmount} currency={currency} />,
          1: <Translation {...TXTCLI_Casino} />,
          2: description,
          3: (
            <Translation
              {...TXTCLI_in_N0_h_N1_min}
              values={{ 0: expiresIn.hours, 1: expiresIn.minutes }}
            >
              {(translation) => <span className={sharedStyles.nowrap}>{translation}</span>}
            </Translation>
          )
        }}
      />

      <Translation
        tagName="p"
        {...TXTWCL_If_you_wish_to_see_more_inform_ELL}
        values={{
          a: translatedLink({
            href: '/account/my-stars/bonus/instant-bonuses',
            onClick: viewBonuses
          })
        }}
      />

      <Buttons
        actionList={actions}
        notificationType={type}
        attributes={attributes}
        notificationId={notificationId}
        onClickPrimaryAction={onClickPrimaryAction}
      />
    </NotificationContainer>
  );
};

export default Expired;
